<template>
  <div class="card-data">
    <Tooltip 
    :tip="tip" />
    <div class="card-title">
      <h5 class="title">{{title}}</h5>
    </div>
    <div v-if="!loader">
        <Loader/>
    </div>
      <!-- <EmptyStateChart v-else-if="valueReach==0&&loader"
      :title="titleEmpty"
      :caption="captionEmpty"
      /> -->
    
    <!-- <div class="reach" id="total" v-else-if="loader&&valueReach!=0"> -->
    <div class="reach" id="total" v-else-if="loader">
      <div class="all-interactions">
        <h6 class="subtitle">{{subtitle}}</h6>
        
        <p class="total-interactions"> $ 
          <ICountUp
              :endVal="totalRevenue"
              :options="options"
              />
        </p>
      </div>
      <!-- <div class="counter"> -->
                <!-- <ICountUp
                    :endVal="total"
                    :options="options(total)"
                    class="value"
                    />
                <i class="ico-up-triangle-fill indicator up" src="@/assets/icons/up.svg" alt="Indicador" v-if="amountUp"></i>
                <i class="indicator ico-equals-fill equal" v-else-if="total==previous"></i>
                <i class="ico-down-triangle-fill indicator down" alt="Indicador"  v-else></i> -->
                <!-- <p class="value">$ 873.00.142</p><i class="ico-down-triangle-fill indicator down"></i> -->
      <!-- </div> -->
        <!-- <ICountUp
                    :endVal="total"
                    :options="options(total)"
                    class="prev-value"
                    /> -->
      <!-- <p class="prev-value">$ 973.009.142</p> -->
      <div class="all-interactions">
        <h6 class="subtitle">{{subtitle2}}</h6>
        <!-- <ICountUp
                    :endVal="total"
                    :options="options(total)"
                    class="prev-value"
                    /> -->
        <p class="total-interactions">
          <ICountUp
              :endVal="valueReach"
              :options="options"
              class="prev-value"
              />
        </p>
      </div>
    </div>
    
  </div>
</template>
<script>
import ICountUp from 'vue-countup-v2'
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'

export default {
  name: 'ReachCard',
  components: {
    ICountUp,
    Loader,
    Tooltip,
    EmptyStateChart
  },
  data: function(){
    return {
      //
    }
  },
  computed: {
    options: function(){
        return {
            useEasing: true,
            useGrouping: true,
            duration: 0.6,
            separator: '.',
            decimal: ',',
            prefix: '',
            suffix: ''
        }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    subtitle2: {
      type: String,
      required: true
    },
    valueReach:{
      type: Number
    },
    totalRevenue:{
      type: Number
    },
    tip: {
      type: String,
      required: true
    },
    loader: {
      type: Boolean,
      default: false
    },
    captionEmpty:{
        type: String,
        default: "Puedes consultar la vista de los últimos 7 o 30 días.",
    },
    titleEmpty: {
        type: String,
        default: "Este gráfico no esta disponible para esta vista"
    }
  }
}
</script>
<style lang="sass">
.reach
  display: flex
  flex-direction: column
  font-family: $title-font
  box-sizing: border-box
  padding-bottom: 16px
  .subtitle
    text-align: left
    font-size: 14px
    width: 100%
  .counter
    font-size: 24px
    display: flex
    .value
      text-align: right
      flex-grow: 2
    .indicator
      font-size: 16px
  .prev-value
    flex-grow: 2
    width: 100%
    text-align: right
    font-size: 14px
.all-interactions
  display: flex
  flex-direction: column
  width: 100%
  .subtitle
    text-align: left
    width: 100%
  .total-interactions
    text-align: right
    width: 100%
    font-size: 20px
    font-family: $title-font
    font-weight: 600
</style>